package com.eladfinish.bible.contest.screens.main.data

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.StrokeJoin
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathParser
import androidx.compose.ui.unit.dp

/**
 * "Rotating verse widget" icon: a widget card with lines of text, and a small circular arrow in its corner
 * for the verse that changes. The icon is tinted at render time, so the colors here are irrelevant.
 */
val VerseWidgetIcon: ImageVector by lazy {
    fun nodes(pathData: String) = PathParser().parsePathString(pathData).toNodes()
    val tint = SolidColor(Color.Black)
    ImageVector.Builder(
        name = "VerseWidget",
        defaultWidth = 24.dp,
        defaultHeight = 24.dp,
        viewportWidth = 24f,
        viewportHeight = 24f,
    ).apply {
        listOf(CARD_PATH, TEXT_LINES_PATH, ARROW_PATH).forEach {
            addPath(
                pathData = nodes(it),
                stroke = tint,
                strokeLineWidth = 1.4f,
                strokeLineCap = StrokeCap.Round,
                strokeLineJoin = StrokeJoin.Round,
            )
        }
    }.build()
}

private const val CARD_PATH = "M5 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"
private const val TEXT_LINES_PATH = "M7 9h10M7 12.5h5"

// An arc almost all the way round, ending in an arrow head
private const val ARROW_PATH = "M16.5 17a2.5 2.5 0 1 1-.7-1.75M16.8 14.2v1.2h-1.2"
